import PropTypes from 'prop-types'
import {Form, Field} from 'formik'
import {
  Text,
  Button,
  Box,
  FormControl,
  FormLabel,
  Input,
  InputGroup,
  InputRightElement,
} from '@chakra-ui/react'
import {useTranslation} from 'react-i18next'

import FormField from '~/react/components/FormField'
import {EmailIcon, PadlockIcon} from '~/react/icons'

import {
  conversionRatePartnerShape,
  conversionRateValues,
} from './conversionRate'
import TermsLinks from './TermsLinks'
import TermsModal from './TermsModal'
import AuthoriseCheckbox from './AuthoriseCheckbox'

const NullState = ({
  partner,
  isSubmitting,
  onSubmit,
  onCancel,
  onShowTermsModal,
  agreed,
  toggleAgreed,
  connectDisabled,
}) => {
  const {t} = useTranslation('points')

  return (
    <Form>
      <Text>
        {t(
          'points:qantasConnectionDrawer.nullState.title',
          conversionRateValues(partner),
        )}
      </Text>

      <TermsModal onShowTermsModal={onShowTermsModal} />

      <FormField
        type="text"
        name="firstName"
        label={t('points:connectionDrawer.fields.firstName.label')}
        placeholder={t('points:connectionDrawer.fields.firstName.placeholder')}
      />

      <FormField
        type="text"
        name="lastName"
        label={t('points:connectionDrawer.fields.lastName.label')}
        placeholder={t('points:connectionDrawer.fields.lastName.placeholder')}
      />

      <FormField
        type="email"
        name="email"
        label={t('points:connectionDrawer.fields.email.label')}
        placeholder={t('points:connectionDrawer.fields.email.placeholder')}
        icon={<EmailIcon />}
      />

      <Field name="abn">
        {({field}) => (
          <FormControl pb="sm">
            <FormLabel>
              <Text textStyle="body-small">
                {t('points:connectionDrawer.fields.abn.label')}
              </Text>
            </FormLabel>
            <InputGroup size="lg">
              <Input
                disabled
                backgroundColor="mld.neutral.100"
                size="lg"
                fontSize="base"
                type="text"
                name={field.name}
                value={field.value}
              />
              <InputRightElement>
                <PadlockIcon />
              </InputRightElement>
            </InputGroup>
            <Text textStyle="body-small" mt="xs">
              {t(
                'points:qantasConnectionDrawer.nullState.businessNumberNotice',
              )}
            </Text>
          </FormControl>
        )}
      </Field>

      <Box py="md" borderBottom="1px solid" borderColor="mld.neutral.100">
        <TermsLinks />
      </Box>

      <Box py="md" borderBottom="1px solid" borderColor="mld.neutral.100">
        <AuthoriseCheckbox agreed={agreed} toggle={toggleAgreed} />
      </Box>

      <Box mt="md">
        <Button
          mr="sm"
          variant="primary"
          onClick={onSubmit}
          isDisabled={connectDisabled}
          isLoading={isSubmitting}
        >
          {t('points:qantasConnectionDrawer.nullState.submit')}
        </Button>
        <Button variant="tertiary" onClick={onCancel}>
          {t('points:connectionDrawer.buttons.cancel')}
        </Button>
      </Box>
    </Form>
  )
}

NullState.propTypes = {
  partner: conversionRatePartnerShape,
  isSubmitting: PropTypes.bool.isRequired,
  onSubmit: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
  onShowTermsModal: PropTypes.func.isRequired,
  agreed: PropTypes.bool.isRequired,
  toggleAgreed: PropTypes.func.isRequired,
  connectDisabled: PropTypes.bool.isRequired,
}

NullState.defaultProps = {
  partner: null,
}

export default NullState
